
import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { useTranslation } from "react-i18next";

const ReusableTable = ({
  data,
  isLoading,
  setZatcaIndex = () => { },
  loadingIcon = null,
  columns = [],
  tableStyle = { minWidth: "50rem" },
  paginator = false,
  emptyMessage = "NoResultsFound.",
  rootyStyles = "overflow-auto border border-gray-300 rounded-md custom-table",
  rowClassName = "",
  rest,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <DataTable
      key={i18n.language}
      onRowClick={(e) => {
        setZatcaIndex(e?.index);
      }}
      loadingIcon={loadingIcon}
      value={isLoading ? Array(7).fill({}) : data}
      tableStyle={tableStyle}
      paginator={paginator}
      emptyMessage={t(emptyMessage)}
      rowClassName={rowClassName}
      pt={{
        root: { className: "custom-table" },
        loadingIcon: { className: "text-primary" },
        loadingOverlay: { className: "bg-[rgba(0,0,0,0.2)]" },
        wrapper: { className: "overflow-x-auto border border-b-0 border-gray-300 rounded-md" },
        table: { className: "rounded-md overflow-hidden" },
      }}
      footerColumnGroup={rest?.footerColumnGroup}
      {...rest}
    >
      {columns?.map((col, index) => (
        <Column
          key={index}
          field={col?.field}
          header={col?.header}
          body={
            isLoading ? <Skeleton width="100%" height="1.5rem" /> : col?.body
          }
          style={{ ...col.style }}
          pt={{
            headerCell: {
              className: `!px-[0.5rem] !py-[0.4rem] !bg-gray-300 ${i18n.language === "ar" ? "text-right" : "text-left"
                } ${col.headerCellClass || ""}`,
              ...col.pt?.headerCell,
            },
            headerTitle: {
              className: `text-[13px]  text-gray-900 !font-[600] whitespace-nowrap ${col.headerTitleClass || ""}`,
            },
            bodyCell: {
              className: `!px-[0.5rem] !py-[0.3rem] text-[13px] text-gray-600 leading-[1rem] border-b !border-b-gray-200 bg-white ${i18n.language === "ar" ? "text-right" : "text-left"
                } whitespace-nowrap
               ${col.bodyCellClass || ""} `,
              ...col.pt?.bodyCell,
            },
            ...col.pt,
          }}
          {...col.extraProps}
        />
      ))}
    </DataTable>
  );
};

export default ReusableTable;
